// src/pages/BranchTransferList/components/exportBranchTransferCsv.js
import { formatToCompanyTimezone } from "../../../../lib/functions";

const fmt = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

const fmtDate = (v) => (v ? formatToCompanyTimezone(v).split(" ")[0] : "-");

/**
 * @param {object} params
 * @param {Array}   params.list     - from Redux state.branchTransferList.list
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportBranchTransferCsv = ({
  list,
  title    = "Branch Transfer List",
  filename = "branch_transfer_list",
}) => {
  const headers = [
    "No.", "Date", "Branch Name", "From Account",
    "To Account", "Tran By", "Amount",
  ].map(escape);

  const dataRows = list.map((row, i) => [
    i + 1,
    fmtDate(row.tran_date),
    row.name          || "",
    row.from_acc_name || "",
    row.to_acc_name   || "",
    row.full_name     || "",
    fmt(row.tran_amount),
  ].map(escape));

  const totalAmount = list.reduce((s, r) => s + Number(r.tran_amount || 0), 0);

  const totalRow = [
    "Grand Total:", "", "", "", "", "",
    fmt(totalAmount),
  ].map(escape);

  const rows = [[title], [], headers, ...dataRows, [], totalRow];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};